export { AlgoliaInsightsMiddleware } from "./algolia-insights-middleware";